export const days = [
    { day: 'MONDAY', start_time: null, end_time: null },
    { day: 'TUESDAY', start_time: null, end_time: null },
    { day: 'WEDNESDAY', start_time: null, end_time: null },
    { day: 'THURSDAY', start_time: null, end_time: null },
    { day: 'FRIDAY', start_time: null, end_time: null },
    { day: 'SATURDAY', start_time: null, end_time: null },
    { day: 'SUNDAY', start_time: null, end_time: null },
];